module.exports = __webpack_public_path__ + "static/media/loading2.5324b6f1.gif";